// extracted by mini-css-extract-plugin
export default {"checkout":"Checkout_checkout__GbPbI","wrapper":"Checkout_wrapper__bA62V","head":"Checkout_head__Sn87o"};